import { UIMatch } from "react-router-dom";

/**
 * "closed": starts closed, and opening it isn't saved, e.g. the designer, whose canvas
 * wants the width. "hidden": no menu and an empty top bar, e.g. quick start.
 */
export type PageMenuMode = "closed" | "hidden";

/** What a route under `PageLayout` asks of the layout, set as its `handle`. */
export interface PageRouteHandle {
  menu?: PageMenuMode;
}

/** The innermost matched route's choice wins. */
export function getMenuMode(matches: UIMatch[]): PageMenuMode | undefined {
  for (let index = matches.length - 1; index >= 0; index--) {
    const menu = (matches[index].handle as PageRouteHandle | undefined)?.menu;

    if (menu) {
      return menu;
    }
  }

  return undefined;
}
